import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipConditions {
                        id,
                        type,
                        relationship_condition_models_value,
                        relationshipRule {
                            id,
                            name
                        },
                        relationshipConditionField {
                            id,
                            name
                        },
                        relationshipConditionOperator {
                            id,
                            name
                        },
                        relationshipConditionDataType {
                            id,
                            name
                        },
                        parent {
                            id
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    fetchWhere(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipConditions (
                        id: ${id},
                    ) {
                        id,
                        type,
                        relationship_condition_models_value,
                        relationshipRule {
                            id,
                            name
                        },
                        relationshipConditionField {
                            id,
                            name
                        },
                        relationshipConditionOperator {
                            id,
                            name
                        },
                        relationshipConditionDataType {
                            id,
                            name
                        },
                        parent {
                            id
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    updateRelationshipCondition (
                        id: ${id},
                        relationship_condition_models_value: "${data.relationship_condition_models_value !== null ? data.relationship_condition_models_value : ''}",
                        relationship_rule_id: ${data.relationship_rule_id},
                        relationship_condition_models_field_id: ${data.relationship_condition_models_field_id},
                        relationship_condition_models_operator_id: ${data.relationship_condition_models_operator_id},
                        relationship_condition_models_data_type_id: ${data.relationship_condition_models_data_type_id},
                        parent_id: ${data.parent_id},
                        type: ${data.type}
                    ) {
                        id,
                        type,
                        relationship_condition_models_value,
                        relationshipRule {
                            id,
                            name
                        },
                        relationshipConditionField {
                            id,
                            name
                        },
                        relationshipConditionOperator {
                            id,
                            name
                        },
                        relationshipConditionDataType {
                            id,
                            name
                        },
                        parent {
                            id
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    createRelationshipCondition (
                        relationship_condition_models_value: "${data.relationship_condition_models_value !== null ? data.relationship_condition_models_value : ''}",
                        relationship_rule_id: ${data.relationship_rule_id},
                        relationship_condition_models_field_id: ${data.relationship_condition_models_field_id},
                        relationship_condition_models_operator_id: ${data.relationship_condition_models_operator_id},
                        relationship_condition_models_data_type_id: ${data.relationship_condition_models_data_type_id},
                        parent_id: ${data.parent_id},
                        type: ${data.type}
                    ) {
                        id,
                        type,
                        relationship_condition_models_value,
                        relationshipRule {
                            id,
                            name
                        },
                        relationshipConditionField {
                            id,
                            name
                        },
                        relationshipConditionOperator {
                            id,
                            name
                        },
                        relationshipConditionDataType {
                            id,
                            name
                        },
                        parent {
                            id
                        },
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteRelationshipCondition (
                        id: ${id}
                    )
                }
            `
        })
    }
}